import { Icon } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Legal } from '../../../../../../../types/SMT';
import LabeledParamFallback from '../../../../../../common/src/components/label-param-fallback/LabelParamFallback';
import RiskObjectSelectRadio from '../RiskObjectSelectRadio';

interface Props {
  legal: Legal;
  isSelected: boolean;
  onSelect: () => void;
}

const LegalSelectRadio: React.FC<Props> = ({ legal, isSelected, onSelect }) => {
  const { t } = useTranslation();
  const { name, status } = legal;

  return (
    <RiskObjectSelectRadio
      isSelected={isSelected}
      onSelect={onSelect}
      icon={
        <Icon
          name="IconFamilyFilled"
          color={isSelected ? 'primary.500' : undefined}
        />
      }
      title={name || ''}
    >
      <LabeledParamFallback label={t('HOME-SITUATION')}>
        {status ? t(status) : undefined}
      </LabeledParamFallback>
    </RiskObjectSelectRadio>
  );
};

export default LegalSelectRadio;
